import { Stack, useTheme, useMediaQuery, Button } from "@mui/material";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import CommentIcon from "@mui/icons-material/Comment";

interface Props {
  setDrawerOpen: (open: boolean) => void;
  setSelectedDrawerPanel: (panel: "details" | "comments") => void;
}

const DrawerControlButtons = ({
  setDrawerOpen,
  setSelectedDrawerPanel,
}: Props) => {
  const theme = useTheme();
  const screenIsLarge = useMediaQuery(theme.breakpoints.up("xl"));

  if (screenIsLarge) {
    return null;
  }

  return (
    <Stack
      direction="row"
      sx={{
        gap: 2,
      }}
    >
      <Button
        variant="outlined"
        startIcon={<DescriptionOutlinedIcon />}
        onClick={() => {
          setDrawerOpen(true);
          setSelectedDrawerPanel("details");
        }}
      >
        Careplan
      </Button>
      <Button
        variant="outlined"
        startIcon={<CommentIcon />}
        onClick={() => {
          setDrawerOpen(true);
          setSelectedDrawerPanel("comments");
        }}
      >
        Comments
      </Button>
    </Stack>
  );
};

export default DrawerControlButtons;
